<template>
  <div>
    <b-input
      :type="type"
      v-model="displayValue"
      @blur="isInputActive = false; $emit('blur')"
      class="inputCurrency"
      :class="{ inputCurrencySaisie: isInputActive }"
      @focus="isInputActive = true; $emit('focus')"
      :placeholder="placeholder"
      :disabled="disabled"
      @keyup.native="$emit('keyup')"
      @keydown.native="$emit('keydown')"/>
  </div>
</template>
<script>
import decimalsFormater from '@/services/general/decimalsFormater';

export default {
  name: 'input-currency',
  props: ['value', 'placeholder', 'disabled'],
  data() {
    return {
      isInputActive: false,
      type: 'search',
    };
  },
  computed: {
    displayValue: {
      get() {
        if (!this.value && this.value !== 0) {
          return null;
        }
        if (this.isInputActive) {
          return this.value.toString();
        }
        return decimalsFormater(this.value).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1 ').replace('.', ',');
      },
      set(modifiedValue) {
        if (!modifiedValue) {
          this.$emit('input', null);
          return;
        }
        const value = modifiedValue.replace(',', '.').replace(/[^\d.]/g, '');
        let newValue = parseFloat(value);
        if (isNaN(newValue)) {
          newValue = 0;
        }
        this.$emit('input', newValue);
      },
    },
  },
  beforeMount() {
    if (this.disabled) {
      this.type = 'text';
    }
  },
};
</script>
<style lang="scss">
.inputCurrency input{
  text-align: right;
}

.inputCurrencySaisie input{
  text-align: left;
}

/* webkit solution */
::-webkit-input-placeholder { text-align:left; }
/* mozilla solution */
input[type="text"]::-moz-placeholder { text-align:left; }
input[type="text"]:-moz-placeholder { text-align:left; }
</style>



// WEBPACK FOOTER //
// src/components/general/inputCurrency.vue